<template>
  <!-- 头部整体盒子 -->
  <div id="header" :style="style">
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="ccf-logo" style="background: rgba(255, 255, 255, 1);">
        <img src="../assets/img/ccf_logo.jpg" style="width: 90px; object-fit: contain;">
      </div>
      <div style="display: flex; flex-direction: row; align-items: center">
        <div class="language" @click="onLanguageChange">{{language === "zh" ? 'EN' : '中'}}</div>
        <!-- 导航内容 -->
        <div class="header-nav-wrapper">
          <div
            v-for="(item,index) in navList"
            :key="index"
            :class="index===parseInt($store.state.currentIndex) ? 'active' : ''"
            @click="navClick(index,item)"
          >
            <div>
              <span>{{item.name}}</span>
              <i class="underline"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="language" @click="onLanguageChange">{{language=== "zh" ? 'EN' : '中'}}</div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <i style="font-size: 20px" :class="menuClass"></i>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index===parseInt($store.state.currentIndex)?'active':''"
            @click="navClick(index,item)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <div>
              {{item.name}}
              <i class="underline"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      style: {
        backgroundColor: "",
      },
      language: localStorage.getItem('language') || 'zh',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: (localStorage.getItem('language') || 'zh') === 'zh' ? "首页" : "Home",
      menuClass: "el-icon-arrow-down",
      navList: [
        {
          name: (localStorage.getItem('language') || 'zh') === 'zh' ? "首页" : "Home",
          path: "/",
          children: []
        },
        {
          name: (localStorage.getItem('language') || 'zh') === 'zh' ? "战略研讨历届活动" : "SiftDB Main Forum",
          path: "/activity",
          children: []
        },
        {
          name: (localStorage.getItem('language') || 'zh') === 'zh' ? "系列论坛历届活动" : "SiftDB Theme Forum",
          path: "/forum-activity",
          children: []
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.$store.commit('currentIndexChange', sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0);
    })
    this.menuName = this.navList[sessionStorage.getItem('navIndex') || 0].name || ((localStorage.getItem('language') || 'zh') === 'zh' ? "首页" : "Home")
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    onLanguageChange() {
      this.language = this.language === 'zh' ? 'en' : 'zh'
      localStorage.setItem('language', this.language)
      location.reload()
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        this.style.backgroundColor = `rgba(61, 61, 61,${Math.min(scrollTop /
        (scrollTop + 80), 0.5)})`;
        this.color = true;
      } else if (scrollTop === 0) {
        this.style.backgroundColor = "transparent";
        this.color = false;
      }
    },
    navClick(index, item) {
      this.$store.state.currentIndex = index
      sessionStorage.setItem('navIndex',index)
      this.menuName = item.name;
      this.$router.push({path: item.path})
    },
    menuClick() {
      if (this.menuClass === "el-icon-arrow-down") {
        this.menuClass = "el-icon-arrow-up";
      } else {
        this.menuClass = "el-icon-arrow-down";
      }
    }
  }
};
</script>
<style scoped>
.ccf-logo {
  width: 120px;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -o-border-radius:100%;
  -ms-border-radius:100%;
  -moz-border-radius:100%;
  -webkit-border-radius:100%;
}
/* 顶部 */
#header {
  top: 0;
  width: 100%;
  left: 0;
  position: fixed;
  transition: all linear 0.5s;
  z-index: 99999;
  color: white;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
  margin: 0 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  height: 100%;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  object-fit: cover;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 40px;
}

#header .header-nav .header-nav-wrapper {
  float: right;
  margin: 0;
  max-width: 600px;
}

#header .header-nav .language {
  cursor: pointer;
  z-index: 9999;
  margin-right: 10px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > div {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > div > div {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > div > div > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #e01073;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > div > div > span {
  font-size: 16px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > div > div:hover {
  color: #e01073;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > div > div:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > div > div:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > div.active > div {
  color: #e01073;
  text-decoration: none;
  border-bottom: 2px solid #e01073;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    display: none;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    object-fit: cover;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > div {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > div {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper  > div > span {
    font-size: 10px;
  }

  #header .header-nav .language {
    position: absolute;
    right: 20px;
    top: 45px;
    cursor: pointer;
  }

  #header .header-nav-m .language {
    position: absolute;
    left: 20px;
    top: 15px;
    cursor: pointer;
    z-index: 9999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue